module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-8-a651919191c1dad2c00560ef918f7d33.jpg";